import EditorOverlayStateEnum from 'EditorOverlay/EditorOverlayConstants';
import isHoverPopup from './isHoverPopup';
import isPopupAssignedToCurrentSigner from './isPopupAssignedToCurrentSigner';
import isRequestSignaturePopup from './isRequestSignaturePopup';

export default (activePopup, id, popup, mode) => {
  // The active popup should have a toolbar if and only if it is editable by the current user.
  // Hover popups (eraser, redact, highlighter) manage their own toolbar visibility on hover.
  if (activePopup === id || isHoverPopup(popup)) {
    if (mode === EditorOverlayStateEnum.EDIT) {
      // Active popups always get toolbars in edit mode.
      return true;
    }

    if (isRequestSignaturePopup(popup)) {
      if (mode === EditorOverlayStateEnum.COMPOSE_REQUEST_FIELDS) {
        // Active signature popups have when editing signature fields.
        return true;
      }

      if (window.Share.isRecipientSigning() || window.Share.isSenderSigning()) {
        if (isPopupAssignedToCurrentSigner(popup)) {
          // In a signing mode, only popups assigned to the current signer get toolbars.
          return true;
        }
      }
    }
  }
  return false;
};



// WEBPACK FOOTER //
// ./src-react/Popups/helpers/hasToolbar.jsx